export class CreationInputError extends Error {
  readonly writeNotAttempted = true
}

export function errorMessage(error: unknown): string {
  const response = (error as { response?: { data?: { message?: string } | string } })?.response?.data
  return typeof response === 'string' ? response : response?.message || (error instanceof Error ? error.message : '')
}

export function uncertainResponse(error: unknown): boolean {
  if ((error as { writeNotAttempted?: boolean })?.writeNotAttempted) return false
  const status = (error as { response?: { status?: number } })?.response?.status
  return !status || status >= 500 || status === 408
}
